<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.listBreadCrumb1"
      ></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">充电订单时段分布列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="list-query-child-div flex" style="align-items:center;">
          <div class="query-title-div">时间筛选阶段</div>
          <div class="query-inputs-div flex-1">
            <el-date-picker
              v-model="searchTime"
              style="width: 100%;"
              :type="dateFlag ? 'daterange' : 'monthrange'"
              size="small"
              :value-format="dateFlag ?'yyyy-MM-dd':'yyyy-MM'"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handleDateChange"
            ></el-date-picker>
          </div>
        </div>
        <div
          class="list-query-child-div flex "
          style="align-items:center;margin-left:10px;"
        >
          <div class="query-title-div">时间筛选类型</div>
          <div class="query-inputs-div">
            <el-radio-group v-model="filterType" @change="filterTypeChange">
              <el-radio label="01">按日期</el-radio>
              <el-radio label="02">按周</el-radio>
              <el-radio label="03">按月份</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="toExportList()">导出</button>
      </div>

      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns1"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      dateFlag: true,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      searchTime: [],
      radio: "",
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime: [],
      showMultiQuerys: false,
      filterType:'',
      operates: {
        width: 220,
        fixed: "right",
        list: [
          // {
          //   id: 'report',
          //   label: '报表',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.id)
          //     this.$store.commit('setPileNo', row.pileNo)
          //     // this.$router.push({
          //     // 	name: pageConfig.reportDetailRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'repair',
          //   label: '维修',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.pileCode)
          //     // this.$router.push({
          //     // 	name: pageConfig.repairListDetail
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.repairListDetail })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'charge',
          //   label: '充电记录',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     debugger
          //     this.$store.commit('setEditId', row.pileCode)
          //     // this.$router.push({ name: pageConfig.chargeDetailRouter });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.chargeDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'fault',
          //   label: '故障记录编辑',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.id)
          //     // this.$router.push({ name: pageConfig.faultDetail });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.faultDetail }).href,
          //       '_blank'
          //     )
          //   }
          // },
          // {
          //   id: 'relation',
          //   label: '关联账号',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileCode)
          //     window.open(
          //             this.$router.resolve({ name: pageConfig.relationNum }).href,
          //             '_blank'
          //     )
          //   }
          // }
        ],
      }, // 列操作按钮
    };
  },
  methods: {
    getWeek() {
      let time = new Date().getTime();
      let endTime = time - 6 * 24 * 3600 * 1000;
      this.searchTime[0] = this.$dayjs(endTime).format("YYYY-MM-DD");
      this.searchTime[1] = this.$dayjs(time).format("YYYY-MM-DD");
      console.log(this.searchTime); // 开始时间
      
    },
    getMonth() {
      let time = new Date().getTime();
      let now = new Date(); // 当前日期
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getFullYear(); // 当前年
      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
      this.searchTime[0] = this.$dayjs(monthStartDate).format("YYYY-MM");
      this.searchTime[1] = this.$dayjs(monthEndDate).format("YYYY-MM");
     
    },
    filterTypeChange(val){
      console.log(val);
      this.queryInfo.filterType = val
      if (val == "01"||val == "02") {
        this.dateFlag = true;
        this.getWeek();
        this.queryInfo.startDate = this.searchTime[0];
        this.queryInfo.endDate = this.searchTime[1];
      } else {
        this.dateFlag = false;
        this.getMonth();
        this.queryInfo.startDate = this.searchTime[0];
        this.queryInfo.endDate = this.searchTime[1];
      }
    },
    init() {
      this.filterType = ''
    this.searchTime = []
    if(this.$route.query.daysChange == 'true'){
      this.getWeek()
      this.queryInfo.startDate = this.searchTime[0];
        this.queryInfo.endDate = this.searchTime[1];
        this.filterType = '01'
      this.queryInfo.filterType = '01'
      console.log(1);
    }else{
      this.dateFlag = false;
      this.getMonth()
      this.queryInfo.startDate = this.searchTime[0];
        this.queryInfo.endDate = this.searchTime[1];
        this.filterType = '02'
      this.queryInfo.filterType = '02'
      console.log(2);
    }
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
       
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      if( !_.searchTime||_.searchTime.length<=0){
        return _.$U.error("请选择时间范围");
      }
      if(!_.queryInfo.filterType){
        return _.$U.error("请选择类型");
      }
      _.$U.showLoading(_);
        _.$H
          .post(_, _.$A.operateStatis.pileOrderDayPage, _.queryInfo)
          .then((res) => {
            _.tableData = res.data.data.content || [];
            _.pagination.total = res.data.data.totalElements || 0;
            _.$U.hideLoading(_);
          });
      
      if (_.queryInfo.filterType == "02") {
        _.$H
          .post(_, _.$A.operateStatis.pileOrderWeekPage, _.queryInfo)
          .then((res) => {
            _.tableData = res.data.data.content || [];
            _.pagination.total = res.data.data.totalElements || 0;
            _.$U.hideLoading(_);
          });
      }
      if (_.queryInfo.filterType == "03") {
        _.$H
          .post(_, _.$A.operateStatis.pileOrderMonPage, _.queryInfo)
          .then((res) => {
            _.tableData = res.data.data.content || [];
            _.pagination.total = res.data.data.totalElements || 0;
            _.$U.hideLoading(_);
          });
      }
    },
    // 选择注册时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.startDate = val[0];
        this.queryInfo.endDate = val[1];
      } else {
        delete this.queryInfo.startDate;
        delete this.queryInfo.endDate;
      }
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //选择时间
    pickdate(time) {
      console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTransactionSucceedTime = time ? time[0] : "";
      _.queryInfo.toTransactionSucceedTime = time ? time[1] : "";
    },
     // 导出
     toExportList() {
      let _ = this;

      if( !_.searchTime||_.searchTime.length<=0){
        return _.$U.error("请选择时间范围");
      }
      if(!_.queryInfo.filterType){
        return _.$U.error("请选择类型");
      }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.operateStatis.pileOrderDayExport, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        var downUrl = 'http://192.168.8.174:7997'+res.data.data.viewPath;
        // var downUrl = 'http://ocharge.shzhida.com:6777'+res.data.data.viewPath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    //重置
    reset() {
      delete this.queryInfo.filterType;
      delete this.queryInfo.startDate;
      delete this.queryInfo.endDate;
      this.filterType = ''
      this.searchTime = [];
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
